<template>
	<Modal 
		@close="close"
		:title="title"
		:width="1200"
	>
		<template #content>

			<table class="features-table">
				<thead>
					<tr>
						<th>Icon</th>
						<th>Name</th>
						<th>Description</th>
						<th>Checks For Project Domain</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(feature, featureIndex) in features" :key="featureIndex">
						<td><Feature :type="feature.type" /></td>
						<td>{{ feature.name }}</td>
						<td>{{ feature.description }}</td>
						<td>{{ feature.containDomain ? "✓" : "" }}</td>
					</tr>
				</tbody>
			</table>
				
		</template>
	</Modal>
</template>

<script>
	import Feature from "./FeatureIcon.vue";
	import Modal from "./Modal.vue";
	export default {
		name: "FeaturesTip",
		props: ["settings"],
		components: { Feature, Modal },
		data() {
			return {
				features: [
					{
						type: "ai_overview",
						containDomain: false,
						name: "AI Overview",
						description:
							"AI Overview in Google Search is a new SERP feature that delivers concise, AI-generated summaries based on the search query results.",
					},
					{
						type: "answer_box",
						containDomain: true,
						name: "Answer Box",
						description: "The Answer Box element is intended to provide a direct answer to a user query.",
					},
					{
						type: "carousel",
						containDomain: false,
						name: "Carousel",
						description:
							"The carousel element usually appears on the top of the results page and presents information relevant to a user query in the form of a list of elements.",
					},
					{
						type: "commercial_units",
						containDomain: true,
						name: "Commercial Units",
						description:
							"Commercial units feature on Google SERP is a unique type of advertising content for travel and tourist attractions",
					},
					{
						type: "events",
						containDomain: false,
						name: "Events",
						description: "Google Events is a rich snippet in SERP that lists valid future events in a certain time and location.",
					},
					{
						type: "explore_brands",
						containDomain: true,
						name: "Explore brands",
						description:
							"The Explore Brands Google SERP feature provides a list of popular brands from the web offering the product(s) used in the search query and may include relevant product images. Clicking a certain brand from the list takes you to the related product page on the brand's website. This feature usually appears for ecommerce keywords.",
					},
					{
						type: "featured_snippet",
						containDomain: true,
						name: "Featured Snippet",
						description:
							"Featured Snippets are specific results featured by Google on the top of the organic part of SERPs. These extra features are supposed to provide a straight answer to questions of users by displaying a piece of information related to a query.",
					},
					{
						type: "find_results_on",
						containDomain: true,
						name: "Find results on",
						description:
							"This feature on Google search displays a carousel of other websites or online directories that Google considers helpful in answering the search query.",
					},
					{
						type: "google_flights",
						containDomain: false,
						name: "Google Flights",
						description:
							"The Flights feature essentially represents information about flights between two destinations for the selected dates.",
					},
					{
						type: "google_hotels",
						containDomain: false,
						name: "Google Hotels",
						description:
							"Google Hotels feature on Google SERP represents a specific type of knowledge graph that shows information about a relevant hotel. Google Hotels feature usually appears for search queries that include a name of a hotel.",
					},
					{
						type: "google_posts",
						containDomain: false,
						name: "Google Posts",
						description:
							"The Google Posts feature allows Google My Business profile owners to share timely texts, events, stories, images, polls, and videos directly on Google search in the knowledge graph.",
					},
					{
						type: "google_reviews",
						containDomain: false,
						name: "Google Reviews",
						description:
							"The Google Reviews feature identifies the presence of user-generated reviews of the local establishment in the knowledge graph.",
					},
					{
						type: "hotels_pack",
						containDomain: false,
						name: "Hotels Pack",
						description:
							"The Hotels Pack feature on Google SERP is displayed for searches related to lodging, accomodation or places to stay in a specific location. Similarly to Local Pack, this Google SERP feature shows a map of the relevant area.",
					},
					{
						type: "images",
						containDomain: true,
						name: "Images",
						description:
							"The Images results show up every time you run a query Google deems related to visual content. This feature appears in the form of a row and is often displayed inside the results page.",
					},
					{
						type: "jobs",
						containDomain: false,
						name: "Jobs",
						description: "Google Jobs is a SERP feature that encompasses job postings from various job sites.",
					},
					{
						type: "knowledge_graph",
						containDomain: true,
						name: "Knowledge Graph",
						description:
							"Knowledge Graph feature displays extra information about the topic of the search query. This SERP feature can also include numerous pictures, searches, links, etc., that are likely relevant to the user's query. Knowledge Graph always appears on the right side of desktop SERPs.",
					},
					{
						type: "local_pack",
						containDomain: true,
						name: "Local Pack",
						description:
							'The main aim of the Local Pack is to provide users with the necessary information about local establishments relevant to their queries. This feature appears inside the SERP in the "3-pack" form and can give info about the listed establishment\'s name, phone number, address, work hours, rating, and location on the map.',
					},
					{
						type: "local_services",
						containDomain: false,
						name: "Local services",
						description:
							"Local service ads (LSA) on Google SERP are displayed for searches related to businesses that provide services in a specific area, such as locksmiths, HVAC, plumbers, legal and financial consultancies, and more.",
					},
					{
						type: "map",
						containDomain: false,
						name: "Map",
						description:
							"Although Local Maps and Maps features are pretty alike, the former serves a specific purpose: it displays the location of the particular place on the map and generates route options between different locations.",
					},
					{
						type: "mention_carousel",
						containDomain: false,
						name: "Mention carousel",
						description:
							"The Mention Carousel feature depicts the set of trustworthy references to the query, usually from product-review sites.",
					},
					{
						type: "multi_carousel",
						containDomain: false,
						name: "Multi carousel",
						description:
							"The Multi Carousel feature of Google SERP is a set of illustrated search suggestions based on the initial search query.",
					},
					{
						type: "paid",
						containDomain: true,
						name: "Paid",
						description: "Paid results are adverts powered by Google Ads and displayed above or beyond organic results.",
					},
					{
						type: "people_also_ask",
						containDomain: false,
						name: "People Also Ask",
						description:
							"The People Also Ask feature provides information in the form of the expandable boxes with questions related to the user query.",
					},
					{
						type: "people_also_search",
						containDomain: false,
						name: "People also search",
						description:
							'The "People also search element" usually appears in the bottom area of SERPs and provides short answers to questions related to the initial query.',
					},
					{
						type: "podcasts",
						containDomain: false,
						name: "Podcasts",
						description:
							'When searchers include the word "podcast" in their query, Google surfaces the Podcasts feature in the results. This element provides a carousel of episodes from Google Podcasts relevant to the topic of the search query. ',
					},
					{
						type: "popular_products",
						containDomain: false,
						name: "Popular products",
						description:
							"Search queries with transactional or commercial intent often trigger the Popular products feature on Google. Desktop results display it as a carousel of product items, while on mobile search, it has the form of an expandable block.",
					},
					{
						type: "questions_and_answers",
						containDomain: true,
						name: "Questions & answers",
						description: "Questions & answers feature on Google SERP is displayed when searches are looking for answers or solutions.",
					},
					{
						type: "recipes",
						containDomain: true,
						name: "Recipes",
						description:
							"Recipes feature on Google is often displayed for queries related to food and dishes. This expandable block contains recipe cards with images, rating, time it takes to prepare a dish, and required ingredients.",
					},
					{
						type: "related_searches",
						containDomain: false,
						name: "Related Searches",
						description:
							"Google displays Related Searches at the bottom of almost every results page. This feature consists of the list of questions connected to the initial query.",
					},
					{
						type: "scholarly_articles",
						containDomain: false,
						name: "Scholarly articles",
						description:
							"For search queries related to comprehensive subjects and research projects, Google often displays the Scholarly articles feature. It provides a preview of several results relevant to the search topic found on Google Scholar.",
					},
					{
						type: "shopping",
						containDomain: true,
						name: "Shopping",
						description: "Google Shopping is the ads service powered by AdWords and Google Merchant Center.",
					},
					{
						type: "short_videos",
						containDomain: false,
						name: "Short Videos",
						description:
							"Short Videos is a Google SERP feature that surfaces short-form videos in search results. Generally, videos displayed in this feature are as less than five minutes in length and recorded in a vertical aspect ratio. ",
					},
					{
						type: "stocks_box",
						containDomain: false,
						name: "Stocks box",
						description:
							"Stocks box feature on Google SERP displays a market summary from Google Finance for a particular company. This feature usually appears in the results for queries that contain a company name or a trading symbol and, but not necessarily, words related to stock market and trading activities.",
					},
					{
						type: "top_sights",
						containDomain: false,
						name: "Top sights",
						description:
							"Top sights or Things to Do element on Google SERP is frequently triggered by search queries that include a location name. This feature displays a carousel of places to visit in the vicinity of the mentioned location. ",
					},
					{
						type: "top_stories",
						containDomain: true,
						name: "Top Stories",
						description:
							"The Top Stories (also referred to as the News Box) feature is triggered by queries that include a news-heavy topic. This feature is usually displayed on the top of SERPs.",
					},
					{
						type: "twitter",
						containDomain: false,
						name: "Twitter",
						description:
							'The "Twitter" feature is often displayed in SERP if the subject of the search query is associated with the relevant Twitter account and/or if the Twitter posts can provide additional information on the subject.',
					},
					{
						type: "video",
						containDomain: false,
						name: "Video",
						description: "Similarly to the Images feature, videos are displayed within the SERPs in the form of a row.",
					},
					{
						type: "visual_stories",
						containDomain: true,
						name: "Visual stories",
						description:
							"Visual stories feature on Google SERP is a unique type of AMP content displayed only on mobile devices. Web Stories blend video, audio, images, text, and animation to provide a dynamic full-screen content experience. ",
					},
				],
			};
		},
    methods: {
      close () {
        this.$emit('close');
      }
    },
		computed: {
			activeFeatures() {
				return this.features.filter((feature) => this.settings.features[feature.type]);
			},
      title () {
        return 'Features';
      }
		},
	};
</script>

<style scoped>
	.features-table {
		width: 100%;
		border-collapse: collapse;
		background-color: #fff;
	}

	.features-table th,
	.features-table td {
		border: 1px solid #ddd;
		padding: 8px;
		text-align: left;
	}

	.features-table th {
		background-color: #f2f2f2;
		font-weight: bold;
	}

	.features-table td:last-child {
		text-align: center;
	}
  .modal:not(.no-overlay) {
    .modal-inner, .modal-inner-scroll {
      max-width: 1200px;
    }
  }
</style>
